import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TimelineScorecard from '../TimelineScorecard.vue'
import { useTimers } from '../../store/timers'
import { useFormatTime } from '../../composables/formatTime'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { computed, inject, Ref, ref } from 'vue'
import FormEndOfDay from './FormEndOfDay.vue'
import FormPayrollCert from './FormPayrollCert.vue'
import { SyncDatabase } from '../../synchronizations/sync'
import { HttpResponse } from '@capacitor-community/http'
import { useRoute, useRouter } from 'vue-router'
import { useTimesheets } from '../../store/timesheets'
import { Timesheet } from '../../types/timers'
import { useGlobalTimesheetInstance } from '../../store/useGlobalTimesheetInstance'
//Total times

export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineScorecardTotalTime',
  setup(__props) {

const { getTotalParentTimes, getAllParentTimers, getActiveParentTimer } = storeToRefs(useTimers())
const { lockTimerEdits } = useTimers()
const { t } = useI18n({ useScope: 'global' })
const scorecardLabelHeader = (key: string) => t(`timeline.${key}`)

const dayModal = ref(false)

const { isLocked } = storeToRefs(useTimers())

const allowedToEndDay = computed(() => {
  return getAllParentTimers.value.length > 0 && !getActiveParentTimer.value && !isLocked.value
})

// const user = storeToRefs(useUserStore())
// const useTravelOverrideModal = computed((): boolean => user.country_id.value == 1)
const useTravelOverrideModal = computed((): boolean => true)
/**Open end of day form, rep will continue to payroll cert form next, and
 * we keep track of the state for 30/30 overrride here.
 */
const openDayModal = () => {
  //guard ending day until at least one activity is present, or if locked
  if (allowedToEndDay.value) {
    if (useTravelOverrideModal.value) {
      dayModal.value = true
    } else {
      applyTravelOverrideRule.value = true
      payrollCertLanguage.value = true
    }
  }
}
const applyTravelOverrideRule = ref(false)
const agreeToLegal = ref()
/**
 * Payroll cert language will follow after a rep clicks continue
 * on the end of day form. The event here is the travel
 * override provided from previous modal.
 */
const payrollCertLanguage = ref(false)
const openPayrollCertLanguage = (e: boolean) => {
  applyTravelOverrideRule.value = e
  payrollCertLanguage.value = true
}

const route = useRoute()
const router = useRouter()
const cancelEdits = inject<() => Promise<void>>('cancelEdits')
const globalTimesheetInstance = inject<Ref<Timesheet>>('globalTimesheetInstance')
const disable = ref(false)
/** End day here. Set flag for end of day in timers. */
const endDay = async (agreeLegal: boolean) => {
  //Need to lock this out panel in case the rep attempts to end day again
  disable.value = true
  //set value if rep agrees/disagrees to legal
  agreeToLegal.value = agreeLegal
  //close modal
  payrollCertLanguage.value = false

  const { sync } = SyncDatabase()
  //use router to determine if current or a timesheet index
  const { editTimeSheetByDate } = useTimesheets()
  if (
    route.name == 'previous_activity' ||
    (globalTimesheetInstance && globalTimesheetInstance.value)
  ) {
    const { flagReadyToSyncByDate } = useTimesheets()
    const { timesheetDateString } = useGlobalTimesheetInstance()
    //edit the timesheet
    const timers_copy = [...getAllParentTimers.value]
    editTimeSheetByDate(timesheetDateString!, timers_copy)
    //mark it ready to sync
    flagReadyToSyncByDate(timesheetDateString!, {
      agree_legal: agreeToLegal.value,
      claim_travel_override: applyTravelOverrideRule.value,
    })
    if (cancelEdits) {
      await cancelEdits()
    }
    await router.push('/previous_activities')
    //initiate a sync
    await sync().finally(() => {
      disable.value = false
    })
  } else {
    await sync({
      timesheetMeta: {
        agree_legal: agreeToLegal.value,
        claim_travel_override: applyTravelOverrideRule.value,
      },
    })
      .then((res: HttpResponse) => {
        console.log('res endDay', res)
        if (res && res.status == 200 && !(res.data.error || res.data.ref_id)) {
          lockTimerEdits()
        }
      })
      .finally(() => {
        disable.value = false
      })
  }
}
const subheader = computed(() => {
  return useFormatTime(getTotalParentTimes)
})

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TimelineScorecard, {
      onClick: openDayModal,
      disable: disable.value,
      header: scorecardLabelHeader('totalTime'),
      subheader: subheader.value
    }, {
      content: _withCtx(() => [
        _withDirectives(_createVNode(_component_q_item_label, { overline: "" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('form.endDay')), 1)
          ]),
          _: 1
        }, 512), [
          [_vShow, allowedToEndDay.value]
        ])
      ]),
      _: 1
    }, 8, ["disable", "header", "subheader"]),
    _createVNode(FormEndOfDay, {
      modelValue: dayModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dayModal).value = $event)),
      onContinueToLegal: openPayrollCertLanguage
    }, null, 8, ["modelValue"]),
    _createVNode(FormPayrollCert, {
      modelValue: payrollCertLanguage.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payrollCertLanguage).value = $event)),
      onEndDay: endDay
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})